import { render, staticRenderFns } from "./SocialShare.vue?vue&type=template&id=d0b0d9e2"
import script from "./SocialShare.vue?vue&type=script&lang=js"
export * from "./SocialShare.vue?vue&type=script&lang=js"
import style0 from "./SocialShare.vue?vue&type=style&index=0&id=d0b0d9e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports